module.exports = __webpack_public_path__ + "static/media/km.a6823869.svg";